import { Fragment } from 'react';
import { Layouts } from '~/shared';
import { rage } from '~/rage';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledBackground, StyledBackgroundDots } from './Background.styled';

const Background: React.FC = () => (
	<Fragment>
		{rage.config.isStub() && (
			<BgPlaceholder $type={PlaceholderType.DefaultNight} />
		)}
		<StyledBackground className={`${Layouts.DeathScreen}-background`}>
			<StyledBackgroundDots />
		</StyledBackground>
	</Fragment>
);

export { Background };
